// To be kept in sync with https://git.hubteam.com/HubSpot/IdentityBase/blob/a73e1f1c58261ff81611e2c90e66b6abdeb370c0/src/main/protobuf/contacts.proto#L211
// (link is to commit as of 4/30/2023, check file at latest master for updates)
export const UNFORMATTED = 'unformatted';
export const FORMATTED = 'formatted';
export const CURRENCY = 'currency';
export const PERCENTAGE = 'percentage';
export const DURATION = 'duration';
export const PROBABILITY = 'probability';